export default __webpack_public_path__ + "static/media/card-link-icon.58ed101a.svg";